import MultipleDevicesCreatedAlert from "./MultipleDevicesCreatedAlert.js";

export default MultipleDevicesCreatedAlert;